

export const useMapStyle = (mode: string) => {

  const client = process.env.REACT_APP_CLIENT || 'core';

  if (client === 'gravity') {
    if (mode === 'dark') {
      return "mapbox://styles/mpilarczykstarcount/clzl1q9lh002u01pd8s03dapo";
    } else {
      return "mapbox://styles/mpilarczykstarcount/cm0tlbxd100p801qudsi79pj0";
    }
  } else if (client === 'miroma') {
    if (mode === 'dark') {
      return "mapbox://styles/mpilarczykstarcount/clzl1q9lh002u01pd8s03dapo";
    } else {
      return "mapbox://styles/mpilarczykstarcount/cm0tlbxd100p801qudsi79pj0";
    }
  } else if (client === 'imedia') {
    if (mode === 'dark') {
      return "mapbox://styles/mpilarczykstarcount/cms9d976e00ac01sdc6qi014m";
    } else {
      return "mapbox://styles/mpilarczykstarcount/cm0tlbxd100p801qudsi79pj0";
    }
  }  else {
    if (mode === 'dark') {
      return "mapbox://styles/mpilarczykstarcount/clz1qpnfl00k301nvgt0qalb9";
    } else {
      return "mapbox://styles/mpilarczykstarcount/clzb9t3jv007g01pl0j634wxi";
    }
  }

}
